import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Activity, DollarSign, TrendingUp, TrendingDown } from "lucide-react";

const Item = ({ icon: Icon, label, data, prefix }) => {
  const up = (data?.change_pct ?? 0) >= 0;
  return (
    <div className="flex items-center gap-2.5">
      <div className="w-8 h-8 rounded-lg bg-[var(--accent)]/12 flex items-center justify-center shrink-0">
        <Icon size={15} className="text-accent" />
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wider text-[var(--text-muted)] leading-none mb-1">{label}</p>
        <div className="flex items-center gap-2">
          <span className="font-mono-data font-bold text-sm">{data ? `${prefix || ""}${data.price.toLocaleString("id-ID")}` : "..."}</span>
          {data && (
            <span className={`font-mono-data text-xs flex items-center gap-0.5 ${up ? "text-bull" : "text-bear"}`}>
              {up ? <TrendingUp size={11} /> : <TrendingDown size={11} />}{up ? "+" : ""}{data.change_pct}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default function MarketBar() {
  const [m, setM] = useState(null);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/market").then((r) => { if (alive) { setM(r.data); setLive(true); } }).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <div className="bg-[var(--surface-card)] border-b border-[var(--border)]" data-testid="market-bar">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-6 py-2.5 flex items-center gap-6 flex-wrap">
        <div className="flex items-center gap-1.5">
          <span className={`w-1.5 h-1.5 rounded-full ${live ? "bg-[var(--bull)] animate-pulse" : "bg-[var(--text-muted)]"}`} />
          <span className="text-[10px] font-mono-data text-[var(--text-muted)] uppercase tracking-wider">{live ? "Live Market" : "Loading"}</span>
        </div>
        <Item icon={Activity} label="IHSG" data={m?.ihsg} />
        <Item icon={DollarSign} label="USD / IDR" data={m?.usdidr} prefix="Rp " />
      </div>
    </div>
  );
}
